import { render, staticRenderFns } from "./InfoBanner.vue?vue&type=template&id=1c55d971&scoped=true&"
import script from "./InfoBanner.vue?vue&type=script&lang=js&"
export * from "./InfoBanner.vue?vue&type=script&lang=js&"
import style0 from "./InfoBanner.vue?vue&type=style&index=0&id=1c55d971&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c55d971",
  null
  
)

export default component.exports